import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { AssignmentChangeCommunicationResultModel } from '../models/assignment-change-communication-result.model';
import { AssignmentCommunicationFeedbackPostModel } from '../models/assignment-communication-feedback-post.model';
import { AssignmentCommunicationFeedbackSubjectModel } from '../models/assignment-communication-feedback-subject.model';
import { AssignmentCommunicationNotesPostModel } from '../models/assignment-communication-note-post.model';
import { AssignmentCommunicationSportAdminsModel } from '../models/assignment-communication-sport-admins.model';
import { AssignmentCommunicationUpdatePostModel } from '../models/assignment-communication-update-post.model';
import { AssignmentCommunicationModel } from '../models/assignment-communication.model';
import { SportDisciplineLeaderModel } from '../models/assignments-communication/sport-discipline-leader.model';

@Injectable({
    providedIn: 'root'
})
export class AssignmentsCommunicationService {

    constructor(private httpClient: HttpClient) { }

    getAssignmentCommunication(assignmentId: number): Observable<AssignmentCommunicationModel> {
        return this.httpClient.get<AssignmentCommunicationModel>(`${environment.api}/assignments/${assignmentId}/communication/communicationDetails`);
    }

    getDisciplineLeaderContacts(assignmentId: number): Observable<SportDisciplineLeaderModel[]> {
        return this.httpClient.get<SportDisciplineLeaderModel[]>(`${environment.api}/assignments/${assignmentId}/communication/disciplineLeader`);
    }

    sendAssignmentCommunicationNote(assignmentId: number, assignmentCommunicationNoteModel: AssignmentCommunicationNotesPostModel): Observable<AssignmentChangeCommunicationResultModel> {
        return this.httpClient.post<AssignmentChangeCommunicationResultModel>(`${environment.api}/assignments/${assignmentId}/communication/note`, assignmentCommunicationNoteModel)
    }

    sendAssignmentCommunicationUpdate(assignmentId: number, assignmentCommunicationUpdateModel: AssignmentCommunicationUpdatePostModel): Observable<AssignmentChangeCommunicationResultModel> {
        return this.httpClient.post<AssignmentChangeCommunicationResultModel>(`${environment.api}/assignments/${assignmentId}/communication/update`, assignmentCommunicationUpdateModel)
    }

    sendAssignmentCommunicationFeedback(assignmentId: number, assignmentCommunicationFeedbackModel: AssignmentCommunicationFeedbackPostModel): Observable<void> {
        return this.httpClient.post<void>(`${environment.api}/assignments/${assignmentId}/communication/feedback`, assignmentCommunicationFeedbackModel)
    }
}
